<div class="container-fluid admin-container mb-5 ">
    <div class="row">
        <div class="col-md-12">
            <div class="page-header">
                <div>
                    <p class="page-title"> {{lblCreateText}} </p>
                </div>
            </div>
        </div>
    </div>
    <form class="padding-bottum-1em" [formGroup]="hospitalForm" (ngSubmit)="onSubmit()" id="hospitalForm" class="row">
        <div class="col-md-3">
            <h3 class="mb-3"><strong>{{resourceKeyValue.facilityInformation}}</strong></h3>
            <div *ngIf="!isEdit && showComboBox" class="form-group">
                <label class="control-label-required" for="customerName"> <span class="required">* </span>
                    {{resourceKeyValue.facilityCustomerName}}</label>
                <select class="custom-select select-field" id="customerName" formControlName="customerName"
                    [(ngModel)]='selectedCutomerValue' (change)="selectIDNCustomerName($event.target.value)"
                    [class.is-invalid]="hospitalForm.controls.customerName.invalid && hospitalForm.controls.customerName.dirty">
                    <option class="select-option" [value]="0" disabled>{{resourceKeyValue.facilityHintSelectCustomer}}
                    </option>
                    <option class="select-option" *ngFor="let customer of allIDNsCustomersFromRSS"
                        [value]="customer.customerName">
                        {{customer.customerName}}</option>
                </select>
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.customerName.invalid && hospitalForm.controls.customerName.dirty"
                    id="name-validation">
                    <small
                        *ngIf="hospitalForm.controls.customerName.errors.required">{{resourceKeyValue.validationNameRequired}}</small>
                    <small
                        *ngIf="hospitalForm.controls.customerName.errors.maxlength">{{resourceKeyValue.validationLengthMustbe200Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.customerName.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div *ngIf="!isEdit && showComboBox" class="form-group">
                <label class="control-label-required" for="selectFacilityName"><span class="required">*
                    </span>{{resourceKeyValue.hospitalName}}</label>
                <select class="custom-select select-field" id="selectFacilityName" formControlName="selectFacilityName"
                    [(ngModel)]='selectedFacilityNameValue' (change)="selectFacilityName($event.target.value)"
                    [class.is-invalid]="hospitalForm.controls.selectFacilityName.invalid && hospitalForm.controls.selectFacilityName.dirty">
                    <option class="select-option" [value]="0" disabled>{{resourceKeyValue.hintSelectFacility}}</option>
                    <option class="select-option" *ngFor="let facility of allCustomerFacilities"
                        [value]="facility?.facilityName">
                        {{facility?.facilityName}}</option>
                </select>
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.selectFacilityName.invalid && hospitalForm.controls.selectFacilityName.dirty"
                    id="selectFacilityName-validation">
                    <small
                        *ngIf="hospitalForm.controls.selectFacilityName.required">{{resourceKeyValue.validationNameRequired}}</small>
                    <small
                        *ngIf="hospitalForm.controls.selectFacilityName.errors.errorName">{{resourceKeyValue.validationHospitalNameAlreadyExist}}</small>
                    <small
                        *ngIf="hospitalForm.controls.selectFacilityName.maxlength">{{resourceKeyValue.validationLengthMustbe200Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.selectFacilityName?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label class="control-label" for="accountNumber">{{resourceKeyValue.hospitalAccountNumber}}</label>
                <input type="text" class="form-control" id="accountNumber"
                    placeholder={{resourceKeyValue.accountNumberPlaceholder}} formControlName="accountNumber"
                    [class.is-invalid]="hospitalForm.controls.accountNumber.invalid && hospitalForm.controls.accountNumber.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.accountNumber.invalid && hospitalForm.controls.accountNumber.dirty"
                    id="accountNumber-validation">
                    <small
                        *ngIf="hospitalForm.controls.accountNumber.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.accountNumber.errors?.containsWhiteSpace">{{resourceKeyValue.whiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label class="control-label-required" for="idn"><span class="required">*
                    </span>{{resourceKeyValue.facilityIDN}}</label>
                <select class="custom-select select-field" id="idn" formControlName="idn" [(ngModel)]='selectedIDNValue'
                    (change)="selectIDMIdnId($event.target.value)">
                    <option class="select-option" [value]=0 disabled>{{resourceKeyValue.hintSelectIDN}}</option>
                    <option class="select-option" *ngFor="let idn of allIDNs" [value]="idn?.id">{{idn?.name}}</option>
                </select>
            </div>

            <div class="form-group">
                <label class="control-label-required" for="txtODS"><span class="required">*
                    </span>{{resourceKeyValue.originatingDataSource}}</label>
                <input type="text" class="form-control" id="txtODS"
                    placeholder={{resourceKeyValue.hintOriginatingDataSource}} formControlName="ods"
                    [class.is-invalid]="hospitalForm.controls.ods.invalid && hospitalForm.controls.ods.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.ods.invalid && hospitalForm.controls.ods.dirty" id="ods-validation">
                    <small
                        *ngIf="hospitalForm.controls.ods.errors.errorODS">{{resourceKeyValue.validationODSAlreadyExist}}</small>
                    <small
                        *ngIf="hospitalForm.controls.ods.errors?.maxlength">{{resourceKeyValue.validationLengthMustbe500Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.ods.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                    <small
                        *ngIf="hospitalForm.controls.ods.errors.required">{{resourceKeyValue.validationODSRequired}}</small>
                </div>
            </div>
            <div class="form-group">
                <span class="switch">
                    <input type="checkbox" id="switch-normal-isCdsSubscribed" class="form-check-input" formControlName="isCdsSubscribed">
                    <label for="switch-normal-isCdsSubscribed"
                        class="form-check-label">{{resourceKeyValue.recievePatientsUpdate}}</label>
                </span>
            </div>
        </div>
        <div class="col-md-3 offset-1">
            <h3 class="mb-3"><strong>{{resourceKeyValue.facilityAddress}}</strong></h3>
            <div class="form-group">
                <label for="countryId">
                    <span class="required">* </span>{{resourceKeyValue.hospitalCountry}}
                </label>
                <select class="custom-select" id="countryId" formControlName="countryId" [(ngModel)]='selectedCountryId'
                    (change)="getAllStatesByCountryId($event.target.value)">
                    <option [value]=0 disabled>{{resourceKeyValue.hintSelectCountry}}</option>
                    <option *ngFor="let country of allCountries" [value]="country?.id">{{country?.name}}</option>
                </select>
            </div>

            <div class="form-group">
                <label class="control-label-required" for="address1"><span class="required">*
                    </span>{{resourceKeyValue.hospitalAddressLine1}}</label>
                <input type="text" class="form-control" id="address1" placeholder={{resourceKeyValue.hintAddressLine1}}
                    formControlName="address1"
                    [class.is-invalid]="hospitalForm.controls.address1.invalid && hospitalForm.controls.address1.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.address1.invalid && hospitalForm.controls.address1.dirty"
                    id="address1-validation">
                    <small
                        *ngIf="hospitalForm.controls.address1.errors.required">{{resourceKeyValue.validationAddressLine1Required}}</small>
                    <small
                        *ngIf="hospitalForm.controls.address1.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.address1.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group">
                <label for="address2">{{resourceKeyValue.hospitalAddressLine2}}</label>
                <input type="text" class="form-control" id="address2" placeholder={{resourceKeyValue.hintAddressLine2}}
                    formControlName="address2"
                    [class.is-invalid]="hospitalForm.controls.address2.invalid && hospitalForm.controls.address2.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.address2.invalid && hospitalForm.controls.address2.dirty"
                    id="address2-validation">
                    <small
                        *ngIf="hospitalForm.controls.address2.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.address2.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                </div>
            </div>

            <div class="form-group">
                <label class="control-label-required" for="city"><span class="required">*
                    </span>{{resourceKeyValue.hospitalCity}}</label>
                <input type="text" class="form-control" id="city" formControlName="city"
                    placeholder={{resourceKeyValue.hintCity}}
                    [class.is-invalid]="hospitalForm.controls.city.invalid && hospitalForm.controls.city.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.city.invalid && hospitalForm.controls.city.dirty" id="city-validation">
                    <small
                        *ngIf="hospitalForm.controls.city.errors.maxlength">{{resourceKeyValue.validationLengthMustbe255Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.city.errors.required">{{resourceKeyValue.validationCityRequired}}</small>
                    <small
                        *ngIf="hospitalForm.controls.city.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                </div>
            </div>
            <div class="form-group" *ngIf="showState">
                <label for="state"><span class="required">* </span>{{resourceKeyValue.hospitalState}}</label>
                <select class="custom-select select-field" id="state" formControlName="state"
                    [(ngModel)]='selectedStateValue'>
                    <option [value]="0" disabled>{{resourceKeyValue.hintSelectState}}</option>
                    <option *ngFor="let state of allStates" [value]="state.code">{{state.name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label class="control-label-required" for="zipCode"><span class="required">*
                    </span>{{resourceKeyValue.hospitalPostalCode}}</label>
                <input type="text" class="form-control" id="zipCode" formControlName="zipCode"
                    placeholder={{resourceKeyValue.hintPostalCode}}
                    [class.is-invalid]="hospitalForm.controls.zipCode.invalid && hospitalForm.controls.zipCode.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.zipCode.invalid && hospitalForm.controls.zipCode.dirty"
                    id="zipCode-validation">
                    <small
                        *ngIf="hospitalForm.controls.zipCode.errors.required">{{resourceKeyValue.validationPostalCodeRequired}}</small>
                    <small
                        *ngIf="hospitalForm.controls.zipCode.errors.maxlength">{{resourceKeyValue.validationLengthMustbe10Characters}}</small>
                    <small
                        *ngIf="hospitalForm.controls.zipCode.errors.pattern">{{resourceKeyValue.validationPostalCode}}</small>
                </div>
            </div>
            <div class="form-group">
                <label class="control-label-required" for="purgeFrequency"><span class="required">*
                    </span>{{resourceKeyValue.hospitalPurgeFrequency}}</label>
                <input type="text" class="form-control" id="purgeFrequency" formControlName="purgeFrequency"
                    placeholder={{resourceKeyValue.hintPurgeFrequency}}
                    [class.is-invalid]="hospitalForm.controls.purgeFrequency.invalid && hospitalForm.controls.purgeFrequency.dirty">
                <div class="invalid-feedback"
                    *ngIf="hospitalForm.controls.purgeFrequency.invalid && hospitalForm.controls.purgeFrequency.dirty"
                    id="purgeFrequency-validation">
                    <small
                        *ngIf="hospitalForm.controls.purgeFrequency.errors.required">{{resourceKeyValue.validationPurgeFrequencyRequired}}</small>
                    <small
                        *ngIf="hospitalForm.controls.purgeFrequency.errors.pattern">{{resourceKeyValue.validationPurgeFrequencyPattern}}</small>
                </div>
            </div>
            <div hidden class="form-group invisible-collapsed" *ngIf="isEdit">
                <label for="id">ID</label>
                <input type="text" class="form-control" id="id" placeholder="ID" formControlName="id" value="0">
            </div>
        </div>
    </form>
    <div class="form-button-fixed">
        <button id="cancelCreateIdnBtn" class="btn btn-secondary" [routerLink]="['/facilities']">
            {{btnCancelText}}
        </button>
        <button id="createIdnBtn" type="submit" class="btn btn-primary ml-3" form="hospitalForm" [disabled]="isLoading || !hospitalForm.valid || (hospitalForm.valid && hospitalForm.pristine) ||
                                                                            selectedIDNValue === 0 || selectedStateValue === '0' ||
        selectedFacilityNameValue === '0' || selectedCutomerValue === '0'">
            {{btnCreateText}}
        </button>
    </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>